import React, { useEffect, useState } from "react";
import { makeStyles, Typography, Grid, Button } from "@material-ui/core/";
import { useSelector, useDispatch } from "react-redux";
import {
  getprofileData,
  postprofileData,
} from "../../../reduxSlices/profileSlice";
import localizedStrings from "../../../utils/localize";
import SnackBar from "../../SnackBar";
import AllFormData from "../profileForms/formData";
const useStyle = makeStyles((theme) => ({
  container: {
    padding: "1rem 0",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  profileFont: {
    fontSize: "1.8rem",
    fontWeight: 500,
    flex: 1,
  },
}));

const TopItems = (props) => {
  const classes = useStyle(props);
  const dispatch = useDispatch();
  const [FormData, setFormData] = useState(AllFormData);
  const [primaryDetails, setPrimaryDetails] = useState(FormData.primaryDetails);
  const profileDataEdit = useSelector(
    (state) => state.profileData.profileDataEdit,
  );
  const [displayMessage, setDisplayMessage] = useState("");
  const [disabledValue, setDisabledValue] = useState(true);
  const [showSnackBar, setShowSnackBar] = useState({
    status: false,
    message: "",
  });
  function validateSIN(sin) {
    // Check if the SIN is exactly 9 digits and the first digit is not 0 or 8
    if (/^\d{9}$/.test(sin) && !["0", "8"].includes(sin[0])) {
      return false;
    } else {
      return true;
    }
  }

  useEffect(() => {
    if (
      profileDataEdit.ses_emergencycontactname === null ||
      profileDataEdit.ses_emergencycontactrelationship === null ||
      profileDataEdit.ses_emergencycontactphone === null ||
      profileDataEdit.ses_emergencycontactname === "" ||
      profileDataEdit.ses_emergencycontactrelationship === "" ||
      profileDataEdit.ses_emergencycontactphone === "" ||
      profileDataEdit.telephone1 === null ||
      profileDataEdit.mobilephone === null ||
      profileDataEdit.telephone1 === "" ||
      profileDataEdit.mobilephone === ""
    ) {
      setDisabledValue(true);
    } else {
      setDisabledValue(false);
    }
  }, [disabledValue, profileDataEdit]);

  const handleSave = () => {
    var validationResult = validateSIN(profileDataEdit.governmentid);
    const newPrimaryDetails = { ...primaryDetails };
    setDisplayMessage("Please enter a valid Social Insurance Number (SIN)");
    if (
      validationResult &&
      !newPrimaryDetails.governmentid.elementConfig.disabled
    ) {
      let status = { ...showSnackBar };
      status.status = true;
      status.message = "Please enter a valid Social Insurance Number (SIN)";
      setShowSnackBar(status);
    }
    if (
      !validationResult ||
      newPrimaryDetails.governmentid.elementConfig.disabled
    ) {
      dispatch(
        postprofileData({
          ...profileDataEdit,
          contactid: window.localStorage.getItem("x-auth-contactId"),
        }),
      );
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  };

  const handleClose = () => {
    let status = { ...showSnackBar };
    status.status = false;
    setShowSnackBar(status);
  };
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);
  return (
    <Grid className={classes.container}>
      <SnackBar
        open={showSnackBar.status}
        message={displayMessage}
        handleClose={handleClose}
      />
      <Typography component="div" className={classes.profileFont}>
        {localizedStrings.students.profile.heading}
      </Typography>
      <Typography component="div">
        <Button
          variant="contained"
          color="primary"
          disabled={disabledValue}
          onClick={handleSave}
        >
          {localizedStrings.students.profile.save}
        </Button>
        <Button
          variant="outlined"
          color="primary"
          style={{ marginLeft: "0.5rem" }}
          onClick={() =>
            dispatch(
              getprofileData(window.localStorage.getItem("x-auth-contactId")),
            )
          }
        >
          {localizedStrings.students.profile.refresh}
        </Button>
      </Typography>
    </Grid>
  );
};

export default TopItems;
